import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ArtistCover from '../components/AristCover'
import {
  useHistory
} from 'react-router-dom'
import { getHomeArtisList } from '../store/actions/homeListArtisAction'

export default function Home() {
  const dispatch = useDispatch()
  const history = useHistory()
  const listArtist = useSelector(state => state.homeListReducer.listArtist)
  // eslint-disable-next-line
  const [searchInput, setSearchInput] = useState('')

  const inputBandArtist = _.debounce((value) => {
    history.push(`/artist/${value}`)
  }, 1200)

  function searchOnClick() {
    history.push(`/artist/${searchInput}`)
  }

  useEffect(() => {
    dispatch(getHomeArtisList())
    // eslint-disable-next-line
  }, [])

  if (!listArtist.length) {
    return <h1> <i className="fas fa-sync fa-spin"></i> loading...</h1>
  }
  return (
    <div className="container">
      <br />
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-8">
          <form className="card card-sm">
            <div className="card-body row no-gutters align-items-center">
              <div className="col-auto">
                <i className="fas fa-search h4 text-body"></i>
              </div>
              <div className="col">
                <input className="form-control form-control-lg form-control-borderless"
                  type="search"
                  placeholder="Search artist"
                  onChange={(event) => {
                    inputBandArtist(event.target.value)
                  }}
                />
              </div>
              <div className="col-auto">
                <button className="btn btn-lg btn-success" type="button"
                  onClick={searchOnClick}
                >Search</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="container mt-5">
        <h4>TOP PICKED ARTIS</h4>
        <div className="row d-flex justify-content-center">
          {listArtist.length < 1 && <h1> <i className="fas fa-sync fa-spin"></i> preparing backstage...</h1>}
          {listArtist.map((artis) => {
            return (
              <div
                key={artis.strArtist}
                className="col-3 mt-3">
                <ArtistCover
                  artis={artis}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
